
import React from "react";
import { isPast, isToday } from "date-fns";
import { cn } from "@/lib/utils";

interface TimeGridProps {
  timeSlots: string[];
  weekDays: Date[];
  handleDateClick: (date: Date) => void;
}

export const TimeGrid: React.FC<TimeGridProps> = ({ 
  timeSlots, 
  weekDays, 
  handleDateClick 
}) => {
  return (
    <>
      {timeSlots.map((time) => (
        <React.Fragment key={time}>
          <div className="relative h-[60px] border-b border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 z-10 sticky left-0">
            <span className="absolute -top-3 text-sm text-muted-foreground dark:text-gray-400 pl-2">
              {time}
            </span>
          </div>
          {weekDays.map((day) => {
            const [hours] = time.split(':').map(Number);
            const clickDate = new Date(day);
            clickDate.setHours(hours, 0, 0, 0);
            const isInPast = isPast(clickDate);
            const today = isToday(day);
            
            return (
              <div
                key={`${day.toISOString()}-${time}`}
                className={cn(
                  "relative h-[60px] border-b border-gray-300 dark:border-gray-700 transition-colors",
                  isInPast 
                    ? "bg-gray-200/70 dark:bg-gray-700/60 cursor-not-allowed"
                    : "hover:bg-muted/50 dark:hover:bg-gray-700/30 cursor-pointer",
                  today && !isInPast && "bg-primary/5 dark:bg-primary/10"
                )}
                onClick={() => {
                  if (!isInPast) {
                    handleDateClick(clickDate);
                  }
                }}
              />
            );
          })}
        </React.Fragment>
      ))}
    </>
  );
};
